import { render, staticRenderFns } from "./PasswordFirstChange.vue?vue&type=template&id=09f5f4a3&"
import script from "./PasswordFirstChange.vue?vue&type=script&lang=js&"
export * from "./PasswordFirstChange.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports